import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import app from './modules/app'
import permission from './modules/permission'
import settings from './modules/settings'
import user from './modules/user'
import errorLog from './modules/errorLog'
import tagsView from './modules/tagsView'
import workFlow from './modules/workFlow'
import message from './modules/message'
import tenant from './modules/tenant'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    permission,
    settings,
    user,
    errorLog,
    tagsView,
    workFlow,
    message,
    tenant
  },
  getters
})

export default store
